export default "__VITE_ASSET__mClPIwl8__"